export const UPDATE_CURRENT_INCIDENT_REQUEST =
  'UPDATE_CURRENT_INCIDENT_REQUEST';
export const UPDATE_CURRENT_INCIDENT_SUCCESS =
  'UPDATE_CURRENT_INCIDENT_SUCCESS';
export const UPDATE_CURRENT_INCIDENT_ERROR = 'UPDATE_CURRENT_INCIDENT_ERROR';
export const CREATE_INCIDENT_REQUEST = 'CREATE_INCIDENT_REQUEST';
export const CREATE_INCIDENT_SUCCESS = 'CREATE_INCIDENT_SUCCESS';
export const CREATE_INCIDENT_ERROR = 'CREATE_INCIDENT_ERROR';

export const UPDATE_INCIDENT_GROUP_REQUEST = 'UPDATE_INCIDENT_GROUP_REQUEST';
export const UPDATE_INCIDENT_GROUP_SUCCESS = 'UPDATE_INCIDENT_GROUP_SUCCESS';
export const UPDATE_INCIDENT_GROUP_ERROR = 'UPDATE_INCIDENT_GROUP_ERROR';

export const UPDATE_INCIDENT_DETAILS_SUCCESS =
  'UPDATE_INCIDENT_DETAILS_SUCCESS';

export const UPDATE_CURRENTLY_SELECTED_GROUP_REQUEST =
  'UPDATE_CURRENTLY_SELECTED_GROUP_REQUEST';
export const UPDATE_CURRENTLY_SELECTED_GROUP_SUCCESS =
  'UPDATE_CURRENTLY_SELECTED_GROUP_SUCCESS';
export const UPDATE_CURRENTLY_SELECTED_GROUP_ERROR =
  'UPDATE_CURRENTLY_SELECTED_GROUP_ERROR';

export const SET_CLONE_DEFAULTS_REQUEST = 'SET_CLONE_DEFAULTS_REQUEST';
export const SET_CLONE_DEFAULTS_SUCCESS = 'SET_CLONE_DEFAULTS_SUCCESS';
export const SET_CLONE_DEFAULTS_ERROR = 'SET_CLONE_DEFAULTS_ERROR';
export const FETCH_CLONE_DEFAULTS_REQUEST = 'FETCH_CLONE_DEFAULTS_REQUEST';
export const FETCH_CLONE_DEFAULTS_SUCCESS = 'FETCH_CLONE_DEFAULTS_SUCCESS';
export const FETCH_CLONE_DEFAULTS_ERROR = 'FETCH_CLONE_DEFAULTS_ERROR';
export const ADD_USER_SCHEDULE_REQUEST = 'ADD_USER_SCHEDULE_REQUEST';
export const ADD_USER_SCHEDULE_SUCCESS = 'ADD_USER_SCHEDULE_SUCCESS';
export const ADD_USER_SCHEDULE_ERROR = 'ADD_USER_SCHEDULE_ERROR';
export const DELETE_USER_SCHEDULE_REQUEST = 'DELETE_USER_SCHEDULE_REQUEST';
export const DELETE_USER_SCHEDULE_SUCCESS = 'DELETE_USER_SCHEDULE_SUCCESS';
export const GET_ALL_USER_SCHEDULE_REQUEST = 'GET_ALL_USER_SCHEDULE_REQUEST';
export const GET_ALL_USER_SCHEDULE_SUCCESS = 'GET_ALL_USER_SCHEDULE_SUCCESS';
export const GET_ALL_USER_SCHEDULE = 'GET_ALL_USER_SCHEDULE';
